<template>
  <div class="laAdvertising">
    <div id="ad-type" class="advertisings">广告形式</div>
    <div class="show-box">
      <div class="phone">
        <img class="image"  src="../assets/static/kaiping.jpg" />
        <img class="image" v-show="seen1" src="../assets/static/yuans.jpg"/>
        <img class="image" v-show="seen2" src="../assets/static/henfu.jpg" />
        <img class="image" v-show="seen3" src="../assets/static/chaping.jpg"/>
      </div>
      <div class="show-box2" >
        <div class="show show-Bg" ref="label" @mouseenter="enter" @mouseleave="leave">
          <div class="title title-color" ref="title1">开屏广告</div>
          <div class="showAdApp title-color" ref="title2">简单来说开屏广告就是app第一次启动打开时出现的广告画面，我们称这种广告为开屏广告。</div>
        </div>
        <div class="show" @mouseenter="enter1" @mouseleave="leave1">
          <div class="title">原生广告</div>
          <div class="showAdApp">原生广告通过“和谐”的内容呈现品牌信息，不破坏用户的体验，为用户提供有价值的信息。让用户自然地接受信息。</div>
        </div>
        <div class="show" @mouseenter="enter1" @mouseleave="leave1">
          <div class="title">横幅广告</div>
          <div class="showAdApp">广告横幅标语 1. 用第三只眼睛看世界。 ——出自:海鸥牌相机广告 2. 安全保障 自有一套 ——出自:安全套 3. 可能是世界上最好的啤酒</div>
        </div>
        <div class="show" @mouseenter="enter1" @mouseleave="leave1">
          <div class="title">插屏广告</div>
          <div class="showAdApp">“插屏插屏，是移动广告的一种常见形式，具有强烈的视觉冲击效果，是移动广告平台主流的广告形式之一。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LaAdvertising",
  data() {
    return {
      seen: true,
      seen1: false,
      seen2: false,
      seen3: false,
    }
  },
  methods: {
    enter() {
      this.seen = true;
    },
    leave() {
      this.seen = false
    },
    enter1() {
      this.seen1 = true;
      let label = this.$refs.label
      label.classList.remove('show-Bg');
      let title1 = this.$refs.title1
      title1.classList.remove('title-color');
      let title2 = this.$refs.title2
      title2.classList.remove('title-color');
    },
    leave1() {
      this.seen1 = false
      let label = this.$refs.label
      window.requestAnimationFrame(() => {
        label.classList.add('show-Bg');
        let title1 = this.$refs.title1
        title1.classList.add('title-color');
        let title2 = this.$refs.title2
        title2.classList.add('title-color');
      })
    },
  }
}
</script>

<style scoped>
.laAdvertising {
  width: 1600px;
  margin: 50px auto;
  height: 700px;
  text-align: center;
}

.advertisings {
  margin: auto;
  font-size: 2rem;
  height: 80px;
  color: #212529;
}

.show-box {
  width: 90%;
  height: 700px;
  margin:0 auto;
  display: flex;
  justify-content: center;
  align-content: center;
}

.show-box2 {
  width: 75%;
  margin: auto;
  display: flex;
  justify-content: space-evenly;
}

.phone {
  position: relative;
  width: 300px;
  height: 550px;
  margin: auto;
}

.show {
  position: relative;
  width: 160px;
  height: 170px;
  border-radius: 15px;
  z-index: 10;
  padding: 40px 24px;
  box-shadow: 0 0 44px rgb(0 0 0 / 6%);
}

.show:hover {
  background: #FF415A;
}

.show:hover .title {
  color: #fff;
}

.show:hover .showAdApp {
  color: #fff;
}


.title {
  color: #333333;
  font-size: 25px;
  font-weight: 500;
  line-height: 30px;
  height: 30px;
  margin-bottom: 24px;
  font-family: PingFang SC;
}


.showAdApp {
  color: #666;
  font-size: 14px;
  line-height: 22px;
  width: 160px;
  height: 170px;
}

.image{
  position: absolute;
  left: 6%;
  top: 3%;
  width: 265px;
  height: 520px;
  border-radius: 22px;
}

.show-Bg {
  background: #FF415A ;
}

.title-color {
  color: white;
}

</style>